import './deathScreen.css'
import type { MessageFormatPart } from '../chatUtils'
import MessageFormatted from './MessageFormatted'
import { withInjectableUi } from './extendableSystem'

type Props = {
  dieReasonMessage: MessageFormatPart[]
}

const DeathScreenBase = ({ dieReasonMessage }: Props) => {
  return (
    <div className='deathScreen-container'>
      <div className="deathScreen">
        <h1 className='deathScreen-title'>You Died!</h1>
        <h5 className='deathScreen-reason'>
          <MessageFormatted parts={dieReasonMessage} />
        </h5>
      </div>
    </div>
  )
}

export default withInjectableUi(DeathScreenBase, 'deathScreen')
